export const HOVER_GROUP = 'session-detail';
